import NetworkIcon from "@assets/svg/Network";
import AccountSettingIcon from "@assets/svg/AccountSettingIcon";
import PaymentIcon from "@assets/svg/PaymentIcon";
import MatchesIcon from "@assets/svg/MatchesIcon";
import ReferralMember from "@assets/svg/ReferralMember";
import HomeIcon from "@assets/svg/HomeIcon";
import JobMatchesIcon from "@assets/svg/JobMatchesIcon";
import AspirationIcon from "@assets/svg/AspirationIcon";
import JobTrackIcon from "@assets/svg/JobTrackIcon";
import MembersIcon from "@assets/svg/MembersIcon";
import SearchIcon from "@assets/svg/SearchIcon";
import CareerIcon from "@assets/svg/CareerIcon";
import ProfileIcon from "@assets/svg/ProfileIcon";
import MyContactsIcon from "@assets/svg/MyContactsIcon";
import AnswersIcon from "@assets/svg/AnswersIcon";
import DashboardIcon from "@assets/svg/DashboardIcon";
import AssessmentIcon from "@assets/svg/AssessmentIcon";
import TransactionIcon from "@assets/svg/TransactionIcon";
import ContactsIcon from "@assets/svg/ContactsIcon";
import CalenderIcon from "@assets/svg/CalenderIcon";
//@ts-ignore
import { ReactComponent as Requirements } from "../../assets/svg/requirements.svg";
//@ts-ignore
import { ReactComponent as RecruitmentAgents } from "../../assets/svg/recruitmentAgents.svg";
import { Settings, UserRound } from "lucide-react";
import UsersIcon from "@assets/svg/UsersIcon";

export const recruiterRoutes = [
  {
    label: "Dashboard",
    route: "/dashboard",
    icon: <DashboardIcon className={"w-3.5 h-3.5"} fill="#4d4d4d" />,
  },
  // {
  //   label: "Search",
  //   route: "/search",
  //   icon: <SearchIcon className={"w-5 h-5"} fill="#4d4d4d" />,
  // },
  {
    label: "Jobs",
    route: "/job",
    icon: <CareerIcon className={"w-3.5 h-3.5"} fill="#4d4d4d" />,
  },
  {
    label: "Requirements",
    route: "/requirements",
    icon: <Requirements fill="#4d4d4d" />,
  },
  {
    label: "Screening",
    route: "/my-assessments",
    icon: <AssessmentIcon className={"w-3.5 h-3.5"} fill="#4d4d4d" />,
  },
  {
    label: "Contacts",
    route: "/contacts",
    icon: <ContactsIcon className={"w-3.5 h-3.5"} fill="#4d4d4d" />,
  },
  {
    label: "Calendar",
    route: "/calendar",
    icon: <CalenderIcon className={"w-3.5 h-3.5"} fill="#4d4d4d" />,
  },
  {
    label: "Hiring Company",
    route: "/hiring-company/partner-companies",
    icon: <ContactsIcon className={"w-3.5 h-3.5"} fill="#4d4d4d" />,
  },
  {
    label: "Settings",
    // route: "/account",
    route: "settings",
    icon: <Settings width={18} height={18} color="#4d4d4d" />,
  },
  // {
  //   label: "Transactions",
  //   route: "/transactions",
  //   icon: <TransactionIcon className={"w-3.5 h-3.5"} fill="#4d4d4d" />,
  // },
  {
    label: "Transactions",
    route: "/transactions",
    icon: <TransactionIcon className={"w-3.5 h-3.5"} fill="#4d4d4d" />,
  },
  // {
  //   label: "Payment Methods",
  //   route: "/payment-method",
  //   icon: <PaymentIcon fill="#4d4d4d" />,
  // },
  {
    label: "My Subscription",
    route: "/subscription",
    icon: <PaymentIcon fill="$4d4d4d" />,
  },
];

export const candidateRoutes = [
  {
    label: "Dashbaord",
    route: "/dashboard",
    icon: <DashboardIcon className={"w-3.5 h-3.5"} fill="#4d4d4d" />,
  },
  {
    label: "Jobs",
    route: "/job",
    icon: <JobMatchesIcon className={"w-3.8 h-3.8"} fill="#4d4d4d" />,
  },
  {
    label: "Profile",
    route: "/my-profile",
    //@ts-ignore
    icon: <ProfileIcon className={"w-3.5 h-3.5"} fill="#4d4d4d" />,
    showLive: true,
  },
  {
    label: "Profile2",
    route: "/my-profile2",
    //@ts-ignore
    icon: <ProfileIcon className={"w-3.5 h-3.5"} fill="#4d4d4d" />,
    showLive: true,
  },
  {
    label: "Profile3",
    route: "/my-profile3",
    //@ts-ignore
    icon: <ProfileIcon className={"w-3.5 h-3.5"} fill="#4d4d4d" />,
    showLive: true,
  },
  {
    label: "Aspirations",
    route: "/aspiration-3",
    icon: <AspirationIcon className={"w-3.8 h-3.8"} fill="#4d4d4d" />,
    showLive: true,
  },
  {
    label: "Aspirations Old",
    route: "/aspiration",
    icon: <AspirationIcon className={"w-3.8 h-3.8"} fill="#4d4d4d" />,
    showLive: true,
  },
  // {
  //   label: "Job Track",
  //   route: "/job-track",
  //   icon: <JobTrackIcon className={"w-3.8 h-3.8"} fill="#4d4d4d" />,
  // },
  // {
  //   label: "Job Matches",
  //   route: "/job-matches",
  //   icon: <JobMatchesIcon className={"w-3.8 h-3.8"} fill="#4d4d4d" />,
  // },

  {
    label: "Calendar",
    route: "/calendar",
    icon: <CalenderIcon className={"w-3.5 h-3.5"} fill="#4d4d4d" />,
  },
  {
    label: "Settings",
    // route: "/account",
    route: "settings",
    icon: <Settings width={18} height={18} color="#4d4d4d" />,
  },
  {
    label: "Referral Member",
    route: "/referral-member",
    icon: <ReferralMember className={"w-3.8 h-3.8"} fill="#4d4d4d" />,
  },
  {
    label: "My Assessment",
    route: "/my-assessments",
    icon: <AssessmentIcon className={"w-3.5 h-3.5"} fill="#4d4d4d" />,
  },
  // {
  //   label: "My Contacts",
  //   route: "/my-contacts",
  //   //@ts-ignore
  //   icon: <MyContactsIcon className={"w-3.5 h-3.5"} fill="#4d4d4d" />,
  // },

  // {
  //   label: "Answers",
  //   route: "/answers",
  //   //@ts-ignore
  //   icon: <AnswersIcon className={"w-3.5 h-3.5"} fill="#4d4d4d" />,
  // },
];

export const referralAmbassadorRoutes = [
  {
    label: "Dashbaord",
    route: "/dashboard",
    icon: <DashboardIcon className={"w-3.5 h-3.5"} fill="#4d4d4d" />,
  },
  // {
  //   label: "Home",
  //   route: "/home",
  //   icon: <HomeIcon fill="#4d4d4d" />,
  // },
  // {
  //   label: "Tracker",
  //   route: "/tracker",
  //   icon: <TrackIcon className={'h-4 w-4'} fill="#4d4d4d" />,
  // },
  // {
  //   label: "Tracker2",
  //   route: "/tracker2",
  //   icon: <TrackIcon className={'h-4 w-4'} fill="#4d4d4d" />,
  // },
  // {
  //   label: "Network",
  //   route: "/network",
  //   icon: <NetworkIcon fill="#4d4d4d" />,
  // },
  {
    label: "Network",
    route: "/network",
    icon: <NetworkIcon fill="#4d4d4d" />,
  },
  {
    label: "Transactions",
    route: "/payment",
    icon: <PaymentIcon fill="#4d4d4d" />,
  },
  // {
  //   label: "Balance",
  //   route: "/balance",
  //   icon: <PaymentIcon fill="#4d4d4d" />,
  // },
  {
    label: "Matches",
    route: "/matches",
    icon: <MatchesIcon fill="#4d4d4d" />,
  },
  // {
  //   label: "Matches 2",
  //   route: "/matches-2",
  //   icon: <MatchesIcon fill="#4d4d4d" />,
  // },
  {
    label: "Profile",
    route: "/profile",
    icon: <UserRound stroke="#4d4d4d" size={17} />,
  },
  {
    label: "Settings",
    // route: "/account",
    route: "/settings",
    icon: <Settings width={18} height={18} color="#4d4d4d" />,
  },
  // {
  //   label: "Payment History",
  //   route: "/payment-history",
  //   icon: <TransactionIcon className={"w-3.5 h-3.5"} fill="#4d4d4d" />,
  // },
];

export const hiringCompanyRoutes = [
  {
    label: "Requirements",
    route: "/requirements",
    icon: <Requirements fill="#4d4d4d" />,
  },
  {
    label: "Calendar",
    route: "/calendar",
    icon: <CalenderIcon className={"w-3.5 h-3.5"} fill="#4d4d4d" />,
  },
  {
    label: "Recruitment Agents",
    route: "/recruitment-agents",
    icon: <RecruitmentAgents fill="#4d4d4d" />,
  },
  {
    label: "Settings",
    route: "/settings/account/personal-details",
    icon: <Settings width={18} height={18} color="#4d4d4d" />,
    includesPath: "/settings",
  },
];
